import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import LinkViewer from './LinkViewer';
var Link = function (_a) {
    var entityKey = _a.entityKey, contentState = _a.contentState, children = _a.children, anchorTarget = _a.anchorTarget, relValue = _a.relValue, settings = _a.settings, href = _a.href, rel = _a.rel, target = _a.target, otherProps = __rest(_a, ["entityKey", "contentState", "children", "anchorTarget", "relValue", "settings", "href", "rel", "target"]);
    var componentData = href
        ? { url: href, rel: rel, target: target }
        : contentState.getEntity(entityKey).getData();
    return (React.createElement(LinkViewer, __assign({ componentData: componentData, anchorTarget: anchorTarget, relValue: relValue, settings: settings }, otherProps), children));
};
Link.propTypes = {
    entityKey: PropTypes.string.isRequired,
    contentState: PropTypes.object.isRequired,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    anchorTarget: PropTypes.string,
    relValue: PropTypes.string,
    settings: PropTypes.object,
    href: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.string,
};
export { Link as Component };
//# sourceMappingURL=LinkComponent.js.map